import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'

// Connects to data-controller="carousel"
// Pass Swiper overrides via data-carousel-options-value='{ "slidesPerView": 2, ... }'.
// Any keys provided there win over the defaults below (breakpoints replace wholesale).
export default class extends Controller {
  static targets = ["video"]
  static values = { options: Object }

  connect() {
    const defaults = {
      modules: [Navigation, Autoplay],
      loop: true,
      speed: 1400,
      spaceBetween: 30,

      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        485: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        }
      },

      navigation: {
        nextEl: '.swiper-button-next-custom',
        prevEl: '.swiper-button-prev-custom',
      }
    }

    this.swiper = new Swiper(this.element, { ...defaults, ...this.optionsValue })
    this.swiper.on("slideChange", () => this.pauseVideos())
  }

  pauseVideos() {
    const command = JSON.stringify({ event: "command", func: "pauseVideo", args: [] })
    this.videoTargets.forEach((video) => video.contentWindow?.postMessage(command, "https://www.youtube.com"))
  }

  setAutoplay(running) {
    if (!this.optionsValue.autoplay) return

    if (running) {
      this.swiper.autoplay.start()
    } else {
      this.swiper.autoplay.stop()
    }
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}
